import React from 'react';
import PropTypes from 'prop-types';

/**
 * SearchKishuName
 */
class SearchKishuName extends React.Component {

  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClearButton = this.handleClearButton.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);

  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      $('#search').blur();
      this.props.actions.clickSearch();
      event.preventDefault();
    }
  }

  handleChange(event) {
    this.setState({ kishu: event.target.value });
    this.props.data.kishu = event.target.value
  }

  handleClearButton() {
    this.setState({ kishu: '' });
    this.props.actions.clickClear();
  }

  handleSearchButton() {
    this.props.actions.clickSearch();
  }

  renderButton() {
    if (this.props.data.kishu != '') {
      // 何か入力されている場合はクリアボタンを表示
      return (
        <a onClick={() => this.handleClearButton()}>
          <i id="quetion" className="clear" />
        </a>
      );
    } else {
      // 入力がない場合は検索ボタンを表示
      return (
        <a onClick={() => this.handleSearchButton()}>
          <i id="quetion" className="search" />
        </a>
      );
    }
  }

  render() {
    const actions = this.props.actions;

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable">
          <p>機種名検索</p>
        </div>

        <div>
          <div className="input_search">
            <input type="text" id="search" maxLength="128"
              value={this.props.data.kishu}
              placeholder="機種名"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              onFocus={() => actions.stopUpdate()}
            />
            {this.renderButton()}
          </div>
        </div>
      </div>
    );
  }
}

SearchKishuName.propTypes = {
  actions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SearchKishuName;
